export default __webpack_public_path__ + "static/media/main-bg.4817cb86.png";